module.exports = __webpack_public_path__ + "img/20191115130909360截图20190822131730215.4e8246b1.jpg";